import {CopyToClipboardButton} from '@github-ui/copy-to-clipboard/Button'

import type {PanelArtifact} from './ArtifactPanelContent'

type ArtifactCopyButtonProps = {
  artifact: PanelArtifact | null
}

export function ArtifactCopyButton({artifact}: ArtifactCopyButtonProps) {
  if (!artifact?.body) return null

  return <CopyToClipboardButton textToCopy={artifact.body} ariaLabel="Copy artifact content" />
}
